"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HISTORY_SNAPSHOT_INTERVAL_SECONDS = exports.HISTORY_SNAPSHOT_INTERVAL_MS = exports.normalizeAttachmentCell = exports.isFileIndexSystemColumnId = exports.isFileIndexManagedColumnData = exports.isFileIndexDatabaseId = exports.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS = exports.FILE_INDEX_ROW_ID_PREFIX = exports.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE = exports.FILE_INDEX_MANAGED_BY = exports.FILE_INDEX_HIGHLIGHT_SCOPES = exports.FILE_INDEX_HIGHLIGHT_EVENTS = exports.FILE_INDEX_DATABASE_PROTECTION_PROPS = exports.FILE_INDEX_DATABASE_ID_PREFIX = exports.FILE_INDEX_COLUMNS = exports.FILE_INDEX_COLUMN_IDS = exports.decodeFileIndexRowSourceBlockId = exports.TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES = exports.orderCanonicalKanbanProperties = exports.KANBAN_SYSTEM_BODY_PROPERTY_TYPES = exports.KANBAN_L2_GROUPABLE_PROPERTY_TYPES = exports.KANBAN_L2_GROUP_MATCHER_NAMES = exports.KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES = exports.KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT = exports.isCanonicalTablePropertyVisible = exports.isCanonicalKanbanL2PropertyShape = exports.getCanonicalKanbanVisiblePropertyIds = exports.DATABASE_VIEW_MODES = exports.createCanonicalTableViewData = exports.createCanonicalKanbanViewData = exports.resolveDatabaseCellStorageKey = exports.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES = exports.DATABASE_LARGE_DATA_POLICY = exports.findFreeCanvasRowRects = exports.findFreeCanvasRect = exports.DEFAULT_CANVAS_PLACEMENT_GAP = exports.createRightSideBranchCandidates = exports.CALENDAR_MAX_VISIBLE_SOURCES = exports.parseServerDatabaseRowShardDocId = exports.parseServerDatabaseRootDocId = exports.parseLocalDatabaseRootDocId = exports.normalizeDatabaseBlockId = exports.isServerDatabaseRowShardDocId = exports.isServerDatabaseRootDocId = exports.isLocalDatabaseRootDocId = exports.extractDatabaseIdFromRootDocId = exports.createServerDatabaseRowShardDocId = exports.createServerDatabaseRootDocId = exports.createLocalDatabaseRootDocId = exports.collectDatabaseStorageSyncDocIds = void 0;
exports.DATABASE_IMPORT_STAGING_ESTIMATED_BYTE_HARD_LIMIT = exports.DATABASE_IMPORT_STAGING_COLUMN_HARD_LIMIT = exports.DATABASE_IMPORT_STAGING_ROW_HARD_LIMIT = exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT = exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD = exports.DATABASE_CELL_VALUE_TOO_LARGE_CODE = exports.DATABASE_CELL_VALUE_HARD_LIMIT_BYTES = exports.DATABASE_CELL_VALUE_WARNING_BYTES = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES = exports.DATABASE_ROW_SHARD_TARGET_BYTES = exports.DATABASE_COLUMN_HARD_LIMIT = exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT = exports.DATABASE_ROW_SYSTEM_FIELD_IDS = exports.DATABASE_ROW_UPDATED_BY_FIELD_ID = exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID = exports.DATABASE_ROW_CREATED_BY_FIELD_ID = exports.DATABASE_ROW_CREATED_TIME_FIELD_ID = exports.DATABASE_ROW_SHARD_ORDER_ARRAY_KEY = exports.DATABASE_ROW_SHARD_ROWS_MAP_KEY = exports.ROW_SHARDED_DATABASE_GATE_MESSAGE = exports.INVALID_DATABASE_STORAGE_MESSAGE = exports.SELECT_OPTION_LEGACY_COLOR_MAP = exports.SELECT_OPTION_COLOR_BY_NAME = exports.SELECT_OPTION_COLOR_VALUES = exports.SELECT_OPTION_COLORS = exports.CANVAS_DATABASE_LAYOUT_ROW_STEP = exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP = exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = exports.CANVAS_DATABASE_LAYOUT_ROW_GAP = exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP = exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT = exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH = exports.MAX_CANVAS_DATABASE_HEIGHT = exports.MIN_CANVAS_DATABASE_HEIGHT = exports.DEFAULT_CANVAS_DATABASE_HEIGHT = exports.DEFAULT_CANVAS_DATABASE_WIDTH = exports.DATABASE_STORAGE_VERSION = exports.ViewBackedAppResourceIdError = exports.viewBackedAppResourceId = exports.parseViewBackedAppResourceId = exports.VIEW_CONFIG_MANAGED_BY = exports.resolveCustomAppStandardDatabaseRole = exports.isUserFacingCustomAppStandardDatabaseRole = exports.isHiddenSystemManagedDatabase = exports.CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES = exports.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX = exports.shouldKeepRowForStatusTracking = exports.isStatusTrackingPredicateConfigured = exports.historySnapshotWindowStartMs = exports.historySnapshotWindowIndex = void 0;
exports.createCanvasDatabaseLayout = createCanvasDatabaseLayout;
exports.createCanvasDatabaseGridLayout = createCanvasDatabaseGridLayout;
exports.canvasDatabaseGeometry = canvasDatabaseGeometry;
exports.serializeCanvasDatabaseXYWH = serializeCanvasDatabaseXYWH;
exports.getRandomSelectOptionColor = getRandomSelectOptionColor;
exports.createSelectOptionColorPicker = createSelectOptionColorPicker;
exports.isDatabaseRowSystemFieldId = isDatabaseRowSystemFieldId;
exports.createDatabaseRowCreationSystemFieldCells = createDatabaseRowCreationSystemFieldCells;
exports.createDatabaseRowUpdateSystemFieldCells = createDatabaseRowUpdateSystemFieldCells;
exports.isDatabaseRowSystemFieldCell = isDatabaseRowSystemFieldCell;
exports.assertDatabaseWriteShapeWithinLimits = assertDatabaseWriteShapeWithinLimits;
exports.assertDatabaseColumnShapeWithinLimits = assertDatabaseColumnShapeWithinLimits;
exports.estimateDatabaseImportPreflight = estimateDatabaseImportPreflight;
exports.assertDatabaseImportPreflightAllowsInlineShardedMutation = assertDatabaseImportPreflightAllowsInlineShardedMutation;
exports.assertDatabaseImportPreflightAllowsShardedMutation = assertDatabaseImportPreflightAllowsShardedMutation;
exports.isValidDatabaseBlockId = isValidDatabaseBlockId;
exports.isShardedDatabaseManifest = isShardedDatabaseManifest;
exports.normalizeDatabaseShardManifest = normalizeDatabaseShardManifest;
exports.planDatabaseShardRowWindow = planDatabaseShardRowWindow;
exports.assertDatabaseRowShardBytesWithinLimits = assertDatabaseRowShardBytesWithinLimits;
exports.estimateDatabaseCellValueBytes = estimateDatabaseCellValueBytes;
exports.assertDatabaseCellValueWithinShardBudget = assertDatabaseCellValueWithinShardBudget;
exports.createShardedDatabaseIdentityProps = createShardedDatabaseIdentityProps;
exports.createDatabaseReferenceProps = createDatabaseReferenceProps;
exports.createLegacyInlineDatabaseIdentityProps = createLegacyInlineDatabaseIdentityProps;
exports.writeSerializedShardedDatabaseIdentity = writeSerializedShardedDatabaseIdentity;
exports.writeSerializedDatabaseReference = writeSerializedDatabaseReference;
exports.resolveDatabaseIdentity = resolveDatabaseIdentity;
exports.assertDatabaseIdentity = assertDatabaseIdentity;
exports.assertDatabaseRuntimeIdentity = assertDatabaseRuntimeIdentity;
exports.createDatabaseShardManifestEntry = createDatabaseShardManifestEntry;
exports.createDatabaseShardManifest = createDatabaseShardManifest;
exports.assertDatabaseShardManifest = assertDatabaseShardManifest;
const database_document_identity_1 = require("./database-document-identity");
var database_document_identity_2 = require("./database-document-identity");
Object.defineProperty(exports, "collectDatabaseStorageSyncDocIds", { enumerable: true, get: function () { return database_document_identity_2.collectDatabaseStorageSyncDocIds; } });
Object.defineProperty(exports, "createLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.createLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "createServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseRootDocId; } });
Object.defineProperty(exports, "createServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.createServerDatabaseRowShardDocId; } });
Object.defineProperty(exports, "extractDatabaseIdFromRootDocId", { enumerable: true, get: function () { return database_document_identity_2.extractDatabaseIdFromRootDocId; } });
Object.defineProperty(exports, "isLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.isLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "isServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerDatabaseRootDocId; } });
Object.defineProperty(exports, "isServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.isServerDatabaseRowShardDocId; } });
Object.defineProperty(exports, "normalizeDatabaseBlockId", { enumerable: true, get: function () { return database_document_identity_2.normalizeDatabaseBlockId; } });
Object.defineProperty(exports, "parseLocalDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.parseLocalDatabaseRootDocId; } });
Object.defineProperty(exports, "parseServerDatabaseRootDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseRootDocId; } });
Object.defineProperty(exports, "parseServerDatabaseRowShardDocId", { enumerable: true, get: function () { return database_document_identity_2.parseServerDatabaseRowShardDocId; } });
const database_large_data_policy_1 = require("./database-large-data-policy");
var calendar_policy_1 = require("./calendar-policy");
Object.defineProperty(exports, "CALENDAR_MAX_VISIBLE_SOURCES", { enumerable: true, get: function () { return calendar_policy_1.CALENDAR_MAX_VISIBLE_SOURCES; } });
var canvas_placement_1 = require("./canvas-placement");
Object.defineProperty(exports, "createRightSideBranchCandidates", { enumerable: true, get: function () { return canvas_placement_1.createRightSideBranchCandidates; } });
Object.defineProperty(exports, "DEFAULT_CANVAS_PLACEMENT_GAP", { enumerable: true, get: function () { return canvas_placement_1.DEFAULT_CANVAS_PLACEMENT_GAP; } });
Object.defineProperty(exports, "findFreeCanvasRect", { enumerable: true, get: function () { return canvas_placement_1.findFreeCanvasRect; } });
Object.defineProperty(exports, "findFreeCanvasRowRects", { enumerable: true, get: function () { return canvas_placement_1.findFreeCanvasRowRects; } });
var database_large_data_policy_2 = require("./database-large-data-policy");
Object.defineProperty(exports, "DATABASE_LARGE_DATA_POLICY", { enumerable: true, get: function () { return database_large_data_policy_2.DATABASE_LARGE_DATA_POLICY; } });
Object.defineProperty(exports, "DOCUMENT_PRODUCT_HARD_LIMIT_BYTES", { enumerable: true, get: function () { return database_large_data_policy_2.DOCUMENT_PRODUCT_HARD_LIMIT_BYTES; } });
var database_title_cell_1 = require("./database-title-cell");
Object.defineProperty(exports, "resolveDatabaseCellStorageKey", { enumerable: true, get: function () { return database_title_cell_1.resolveDatabaseCellStorageKey; } });
var database_view_defaults_1 = require("./database-view-defaults");
Object.defineProperty(exports, "createCanonicalKanbanViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalKanbanViewData; } });
Object.defineProperty(exports, "createCanonicalTableViewData", { enumerable: true, get: function () { return database_view_defaults_1.createCanonicalTableViewData; } });
Object.defineProperty(exports, "DATABASE_VIEW_MODES", { enumerable: true, get: function () { return database_view_defaults_1.DATABASE_VIEW_MODES; } });
Object.defineProperty(exports, "getCanonicalKanbanVisiblePropertyIds", { enumerable: true, get: function () { return database_view_defaults_1.getCanonicalKanbanVisiblePropertyIds; } });
Object.defineProperty(exports, "isCanonicalKanbanL2PropertyShape", { enumerable: true, get: function () { return database_view_defaults_1.isCanonicalKanbanL2PropertyShape; } });
Object.defineProperty(exports, "isCanonicalTablePropertyVisible", { enumerable: true, get: function () { return database_view_defaults_1.isCanonicalTablePropertyVisible; } });
Object.defineProperty(exports, "KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT; } });
Object.defineProperty(exports, "KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES; } });
Object.defineProperty(exports, "KANBAN_L2_GROUP_MATCHER_NAMES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_L2_GROUP_MATCHER_NAMES; } });
Object.defineProperty(exports, "KANBAN_L2_GROUPABLE_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_L2_GROUPABLE_PROPERTY_TYPES; } });
Object.defineProperty(exports, "KANBAN_SYSTEM_BODY_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.KANBAN_SYSTEM_BODY_PROPERTY_TYPES; } });
Object.defineProperty(exports, "orderCanonicalKanbanProperties", { enumerable: true, get: function () { return database_view_defaults_1.orderCanonicalKanbanProperties; } });
Object.defineProperty(exports, "TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES", { enumerable: true, get: function () { return database_view_defaults_1.TABLE_DEFAULT_HIDDEN_PROPERTY_TYPES; } });
var file_index_1 = require("./file-index");
Object.defineProperty(exports, "decodeFileIndexRowSourceBlockId", { enumerable: true, get: function () { return file_index_1.decodeFileIndexRowSourceBlockId; } });
Object.defineProperty(exports, "FILE_INDEX_COLUMN_IDS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_COLUMN_IDS; } });
Object.defineProperty(exports, "FILE_INDEX_COLUMNS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_COLUMNS; } });
Object.defineProperty(exports, "FILE_INDEX_DATABASE_ID_PREFIX", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_DATABASE_ID_PREFIX; } });
Object.defineProperty(exports, "FILE_INDEX_DATABASE_PROTECTION_PROPS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_DATABASE_PROTECTION_PROPS; } });
Object.defineProperty(exports, "FILE_INDEX_HIGHLIGHT_EVENTS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_HIGHLIGHT_EVENTS; } });
Object.defineProperty(exports, "FILE_INDEX_HIGHLIGHT_SCOPES", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_HIGHLIGHT_SCOPES; } });
Object.defineProperty(exports, "FILE_INDEX_MANAGED_BY", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_MANAGED_BY; } });
Object.defineProperty(exports, "FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_ROW_HIGHLIGHT_ATTRIBUTE; } });
Object.defineProperty(exports, "FILE_INDEX_ROW_ID_PREFIX", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_ROW_ID_PREFIX; } });
Object.defineProperty(exports, "FILE_INDEX_SOURCE_HIGHLIGHT_CLASS", { enumerable: true, get: function () { return file_index_1.FILE_INDEX_SOURCE_HIGHLIGHT_CLASS; } });
Object.defineProperty(exports, "isFileIndexDatabaseId", { enumerable: true, get: function () { return file_index_1.isFileIndexDatabaseId; } });
Object.defineProperty(exports, "isFileIndexManagedColumnData", { enumerable: true, get: function () { return file_index_1.isFileIndexManagedColumnData; } });
Object.defineProperty(exports, "isFileIndexSystemColumnId", { enumerable: true, get: function () { return file_index_1.isFileIndexSystemColumnId; } });
Object.defineProperty(exports, "normalizeAttachmentCell", { enumerable: true, get: function () { return file_index_1.normalizeAttachmentCell; } });
var history_policy_1 = require("./history-policy");
Object.defineProperty(exports, "HISTORY_SNAPSHOT_INTERVAL_MS", { enumerable: true, get: function () { return history_policy_1.HISTORY_SNAPSHOT_INTERVAL_MS; } });
Object.defineProperty(exports, "HISTORY_SNAPSHOT_INTERVAL_SECONDS", { enumerable: true, get: function () { return history_policy_1.HISTORY_SNAPSHOT_INTERVAL_SECONDS; } });
Object.defineProperty(exports, "historySnapshotWindowIndex", { enumerable: true, get: function () { return history_policy_1.historySnapshotWindowIndex; } });
Object.defineProperty(exports, "historySnapshotWindowStartMs", { enumerable: true, get: function () { return history_policy_1.historySnapshotWindowStartMs; } });
var status_tracking_1 = require("./status-tracking");
Object.defineProperty(exports, "isStatusTrackingPredicateConfigured", { enumerable: true, get: function () { return status_tracking_1.isStatusTrackingPredicateConfigured; } });
Object.defineProperty(exports, "shouldKeepRowForStatusTracking", { enumerable: true, get: function () { return status_tracking_1.shouldKeepRowForStatusTracking; } });
var system_managed_visibility_1 = require("./system-managed-visibility");
Object.defineProperty(exports, "CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX", { enumerable: true, get: function () { return system_managed_visibility_1.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX; } });
Object.defineProperty(exports, "CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES", { enumerable: true, get: function () { return system_managed_visibility_1.CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES; } });
Object.defineProperty(exports, "isHiddenSystemManagedDatabase", { enumerable: true, get: function () { return system_managed_visibility_1.isHiddenSystemManagedDatabase; } });
Object.defineProperty(exports, "isUserFacingCustomAppStandardDatabaseRole", { enumerable: true, get: function () { return system_managed_visibility_1.isUserFacingCustomAppStandardDatabaseRole; } });
Object.defineProperty(exports, "resolveCustomAppStandardDatabaseRole", { enumerable: true, get: function () { return system_managed_visibility_1.resolveCustomAppStandardDatabaseRole; } });
Object.defineProperty(exports, "VIEW_CONFIG_MANAGED_BY", { enumerable: true, get: function () { return system_managed_visibility_1.VIEW_CONFIG_MANAGED_BY; } });
var view_backed_app_resource_id_1 = require("./view-backed-app-resource-id");
Object.defineProperty(exports, "parseViewBackedAppResourceId", { enumerable: true, get: function () { return view_backed_app_resource_id_1.parseViewBackedAppResourceId; } });
Object.defineProperty(exports, "viewBackedAppResourceId", { enumerable: true, get: function () { return view_backed_app_resource_id_1.viewBackedAppResourceId; } });
Object.defineProperty(exports, "ViewBackedAppResourceIdError", { enumerable: true, get: function () { return view_backed_app_resource_id_1.ViewBackedAppResourceIdError; } });
exports.DATABASE_STORAGE_VERSION = 1;
exports.DEFAULT_CANVAS_DATABASE_WIDTH = 800;
exports.DEFAULT_CANVAS_DATABASE_HEIGHT = 300;
exports.MIN_CANVAS_DATABASE_HEIGHT = 180;
exports.MAX_CANVAS_DATABASE_HEIGHT = 1440;
exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH = exports.DEFAULT_CANVAS_DATABASE_WIDTH;
exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT = exports.MAX_CANVAS_DATABASE_HEIGHT;
exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP = 480;
exports.CANVAS_DATABASE_LAYOUT_ROW_GAP = 260;
exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT = 720;
exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP = exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH + exports.CANVAS_DATABASE_LAYOUT_COLUMN_GAP;
exports.CANVAS_DATABASE_LAYOUT_ROW_STEP = exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT + exports.CANVAS_DATABASE_LAYOUT_ROW_GAP;
function createCanvasDatabaseLayout(input) {
    return {
        index: input.index,
        xywh: [
            input.x,
            input.y,
            input.width ?? exports.CANVAS_DATABASE_LAYOUT_NODE_WIDTH,
            input.height ?? exports.CANVAS_DATABASE_LAYOUT_NODE_HEIGHT,
        ],
    };
}
function createCanvasDatabaseGridLayout(index, column, row) {
    return createCanvasDatabaseLayout({
        index,
        x: column * exports.CANVAS_DATABASE_LAYOUT_COLUMN_STEP,
        y: exports.CANVAS_DATABASE_LAYOUT_PAGE_NODE_RESERVED_HEIGHT +
            row * exports.CANVAS_DATABASE_LAYOUT_ROW_STEP,
    });
}
function canvasDatabaseGeometry(layout) {
    const [x, y, width, height] = layout.xywh;
    return { x, y, width, height };
}
function serializeCanvasDatabaseXYWH(layout) {
    return JSON.stringify(layout.xywh);
}
exports.SELECT_OPTION_COLORS = [
    {
        oldColor: 'var(--streamlain-tag-red)',
        color: '#ef4444',
        name: 'Red',
    },
    {
        oldColor: 'var(--streamlain-tag-pink)',
        color: '#c026d3',
        name: 'Magenta',
    },
    {
        oldColor: 'var(--streamlain-tag-orange)',
        color: '#f97316',
        name: 'Orange',
    },
    {
        oldColor: 'var(--streamlain-tag-yellow)',
        color: '#eab308',
        name: 'Yellow',
    },
    {
        oldColor: 'var(--streamlain-tag-green)',
        color: '#22c55e',
        name: 'Green',
    },
    {
        oldColor: 'var(--streamlain-tag-teal)',
        color: '#14b8a6',
        name: 'Teal',
    },
    {
        oldColor: 'var(--streamlain-tag-blue)',
        color: '#2563eb',
        name: 'Blue',
    },
    {
        oldColor: 'var(--streamlain-tag-purple)',
        color: '#7c3aed',
        name: 'Purple',
    },
    {
        oldColor: 'var(--streamlain-tag-gray)',
        color: '#475569',
        name: 'Grey',
    },
];
exports.SELECT_OPTION_COLOR_VALUES = exports.SELECT_OPTION_COLORS.map(color => color.color);
exports.SELECT_OPTION_COLOR_BY_NAME = Object.fromEntries(exports.SELECT_OPTION_COLORS.map(color => [color.name, color.color]));
exports.SELECT_OPTION_LEGACY_COLOR_MAP = Object.fromEntries(exports.SELECT_OPTION_COLORS.map(color => [color.oldColor, color.color]));
function getRandomSelectOptionColor(random = Math.random) {
    const index = Math.floor(random() * exports.SELECT_OPTION_COLOR_VALUES.length);
    return exports.SELECT_OPTION_COLOR_VALUES[index] ?? exports.SELECT_OPTION_COLOR_VALUES[0];
}
function createSelectOptionColorPicker(random = Math.random) {
    let colors = [...exports.SELECT_OPTION_COLOR_VALUES];
    return () => {
        if (colors.length === 0) {
            colors = [...exports.SELECT_OPTION_COLOR_VALUES];
        }
        const index = Math.floor(random() * colors.length);
        const color = colors.splice(index, 1)[0];
        return color ?? exports.SELECT_OPTION_COLOR_VALUES[0];
    };
}
exports.INVALID_DATABASE_STORAGE_MESSAGE = 'database row data must be written through row-sharded storage';
exports.ROW_SHARDED_DATABASE_GATE_MESSAGE = 'row-sharded database storage passes Gate-C and is released';
exports.DATABASE_ROW_SHARD_ROWS_MAP_KEY = 'rows';
exports.DATABASE_ROW_SHARD_ORDER_ARRAY_KEY = 'rowOrder';
exports.DATABASE_ROW_CREATED_TIME_FIELD_ID = 'created-time';
exports.DATABASE_ROW_CREATED_BY_FIELD_ID = 'created-by';
exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID = 'updated-time';
exports.DATABASE_ROW_UPDATED_BY_FIELD_ID = 'updated-by';
exports.DATABASE_ROW_SYSTEM_FIELD_IDS = [
    exports.DATABASE_ROW_CREATED_TIME_FIELD_ID,
    exports.DATABASE_ROW_CREATED_BY_FIELD_ID,
    exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID,
    exports.DATABASE_ROW_UPDATED_BY_FIELD_ID,
];
function isDatabaseRowSystemFieldId(fieldId) {
    return exports.DATABASE_ROW_SYSTEM_FIELD_IDS.includes(fieldId);
}
function databaseRowSystemFieldCell(columnId, value) {
    return { columnId, value };
}
function createDatabaseRowCreationSystemFieldCells(input) {
    const userId = input.userId ?? '';
    return {
        [exports.DATABASE_ROW_CREATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_TIME_FIELD_ID, input.now),
        [exports.DATABASE_ROW_CREATED_BY_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_BY_FIELD_ID, userId),
        [exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID, input.now),
        [exports.DATABASE_ROW_UPDATED_BY_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_BY_FIELD_ID, userId),
    };
}
function createDatabaseRowUpdateSystemFieldCells(input) {
    const userId = input.userId ?? '';
    const cells = {
        [exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_TIME_FIELD_ID, input.now),
        [exports.DATABASE_ROW_UPDATED_BY_FIELD_ID]: databaseRowSystemFieldCell(exports.DATABASE_ROW_UPDATED_BY_FIELD_ID, userId),
    };
    if (typeof input.createdTimeValue !== 'number') {
        cells[exports.DATABASE_ROW_CREATED_TIME_FIELD_ID] = databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_TIME_FIELD_ID, input.now);
    }
    if (typeof input.createdByValue !== 'string') {
        cells[exports.DATABASE_ROW_CREATED_BY_FIELD_ID] = databaseRowSystemFieldCell(exports.DATABASE_ROW_CREATED_BY_FIELD_ID, userId);
    }
    return cells;
}
function isDatabaseRowSystemFieldCell(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    const cell = value;
    if (typeof cell.columnId !== 'string') {
        return false;
    }
    if (!isDatabaseRowSystemFieldId(cell.columnId)) {
        return false;
    }
    return typeof cell.value === 'number' || typeof cell.value === 'string';
}
exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.rootMaterializationGuard.rowHardLimit;
exports.DATABASE_COLUMN_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.database.columnHardLimit;
exports.DATABASE_ROW_SHARD_TARGET_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.targetBytes;
exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.hardLimitBytes;
exports.DATABASE_CELL_VALUE_WARNING_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.cellValueWarningBytes;
exports.DATABASE_CELL_VALUE_HARD_LIMIT_BYTES = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.shard.cellValueHardLimitBytes;
exports.DATABASE_CELL_VALUE_TOO_LARGE_CODE = 'DATABASE_CELL_VALUE_TOO_LARGE';
exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineEstimatedByteWarningThreshold;
exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineEstimatedByteHardLimit;
exports.DATABASE_IMPORT_STAGING_ROW_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.stagingRowHardLimit;
exports.DATABASE_IMPORT_STAGING_COLUMN_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.stagingColumnHardLimit;
exports.DATABASE_IMPORT_STAGING_ESTIMATED_BYTE_HARD_LIMIT = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.stagingEstimatedByteHardLimit;
function assertNonNegativeInteger(value, label) {
    if (!Number.isInteger(value) || value < 0) {
        throw new RangeError(`${label} must be a non-negative integer`);
    }
}
function assertDatabaseWriteShapeWithinLimits({ source, rowCount, columnCount, }) {
    assertNonNegativeInteger(rowCount, 'Database row count');
    assertNonNegativeInteger(columnCount, 'Database column count');
    if (rowCount > exports.ROOT_DOC_ROW_MATERIALIZATION_HARD_LIMIT) {
        throw new RangeError(`${source} has ${rowCount} rows; ${exports.INVALID_DATABASE_STORAGE_MESSAGE}. Owning-doc row materialization is not a product storage path.`);
    }
    if (columnCount > exports.DATABASE_COLUMN_HARD_LIMIT) {
        throw new RangeError(`${source} has ${columnCount} columns; product databases are limited to ${exports.DATABASE_COLUMN_HARD_LIMIT} columns.`);
    }
}
function assertDatabaseColumnShapeWithinLimits({ source, columnCount, }) {
    assertNonNegativeInteger(columnCount, 'Database column count');
    if (columnCount > exports.DATABASE_COLUMN_HARD_LIMIT) {
        throw new RangeError(`${source} has ${columnCount} columns; product databases are limited to ${exports.DATABASE_COLUMN_HARD_LIMIT} columns.`);
    }
}
function estimateImportSampleCellBytes(sampleRows) {
    let cellCount = 0;
    let byteCount = 0;
    for (const row of sampleRows) {
        for (const cell of row) {
            cellCount += 1;
            byteCount += String(cell ?? '').length * 2;
        }
    }
    return cellCount === 0 ? 0 : Math.ceil(byteCount / cellCount);
}
function estimateDatabaseImportPreflight({ source, rowCount, columnCount, fileBytes = 0, sampleRows = [], fixedColumnOverhead = database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.fixedColumnOverhead, }) {
    assertNonNegativeInteger(rowCount, 'Database import row count');
    assertNonNegativeInteger(columnCount, 'Database import column count');
    assertNonNegativeInteger(fileBytes, 'Database import file byte size');
    assertNonNegativeInteger(fixedColumnOverhead, 'Database import fixed column overhead');
    const effectiveColumnCount = columnCount + fixedColumnOverhead;
    const cellCount = rowCount * effectiveColumnCount;
    const averageSampleCellBytes = estimateImportSampleCellBytes(sampleRows);
    const estimatedCellBytes = cellCount * (96 + Math.max(averageSampleCellBytes, 8));
    const estimatedTotalBytes = fileBytes + rowCount * 512 + columnCount * 512 + estimatedCellBytes;
    const estimatedShardCount = estimatedTotalBytes === 0
        ? 0
        : Math.ceil(estimatedTotalBytes / exports.DATABASE_ROW_SHARD_TARGET_BYTES);
    const warnings = [];
    if (rowCount >= database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineWarningRowThreshold) {
        warnings.push(`${source} has ${rowCount} rows; inline import is close to the queued import threshold.`);
    }
    if (columnCount >=
        database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineWarningColumnThreshold) {
        warnings.push(`${source} has ${columnCount} columns; inline import is close to the queued import threshold.`);
    }
    if (estimatedTotalBytes >=
        exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_WARNING_THRESHOLD) {
        warnings.push(`${source} is estimated at ${estimatedTotalBytes} bytes; inline import is close to the queued import threshold.`);
    }
    if (rowCount === 0 || columnCount === 0) {
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'blocked-empty',
            warnings,
            blockReason: `${source} has no importable rows or columns.`,
        };
    }
    const shapeExceedsInlineImport = rowCount > database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockRowThreshold ||
        columnCount > database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockColumnThreshold;
    const bytesExceedInlineImport = estimatedTotalBytes > exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT;
    const shapeExceedsShardedStaging = rowCount > exports.DATABASE_IMPORT_STAGING_ROW_HARD_LIMIT ||
        columnCount > exports.DATABASE_IMPORT_STAGING_COLUMN_HARD_LIMIT;
    const bytesExceedShardedStaging = estimatedTotalBytes > exports.DATABASE_IMPORT_STAGING_ESTIMATED_BYTE_HARD_LIMIT;
    if (shapeExceedsShardedStaging || bytesExceedShardedStaging) {
        const reason = shapeExceedsShardedStaging
            ? `${source} has ${rowCount} rows and ${columnCount} columns; current import staging is limited to ${exports.DATABASE_IMPORT_STAGING_ROW_HARD_LIMIT} rows and ${exports.DATABASE_IMPORT_STAGING_COLUMN_HARD_LIMIT} columns.`
            : `${source} is estimated at ${estimatedTotalBytes} bytes; current import staging is limited to ${exports.DATABASE_IMPORT_STAGING_ESTIMATED_BYTE_HARD_LIMIT} estimated bytes.`;
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'blocked-too-large',
            warnings,
            blockReason: `${reason} Split the file or use a streaming import path.`,
        };
    }
    if (shapeExceedsInlineImport || bytesExceedInlineImport) {
        const reason = shapeExceedsInlineImport
            ? `${source} has ${rowCount} rows and ${columnCount} columns; inline import is limited to ${database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockRowThreshold} rows and ${database_large_data_policy_1.DATABASE_LARGE_DATA_POLICY.import.inlineBlockColumnThreshold} columns.`
            : `${source} is estimated at ${estimatedTotalBytes} bytes; inline import is limited to ${exports.DATABASE_IMPORT_INLINE_ESTIMATED_BYTE_HARD_LIMIT} estimated bytes.`;
        return {
            source,
            rowCount,
            columnCount,
            effectiveColumnCount,
            cellCount,
            estimatedCellBytes,
            estimatedTotalBytes,
            estimatedShardCount,
            allowedAction: 'queued-sharded-import',
            warnings,
            blockReason: `${reason} Queued sharded import is required.`,
        };
    }
    return {
        source,
        rowCount,
        columnCount,
        effectiveColumnCount,
        cellCount,
        estimatedCellBytes,
        estimatedTotalBytes,
        estimatedShardCount,
        allowedAction: 'inline-sharded-import',
        warnings,
    };
}
function assertDatabaseImportPreflightAllowsInlineShardedMutation(estimate) {
    if (estimate.allowedAction !== 'inline-sharded-import') {
        throw new RangeError(estimate.blockReason ?? `${estimate.source} cannot be imported inline.`);
    }
}
function assertDatabaseImportPreflightAllowsShardedMutation(estimate) {
    if (estimate.allowedAction !== 'inline-sharded-import' &&
        estimate.allowedAction !== 'queued-sharded-import') {
        throw new RangeError(estimate.blockReason ??
            `${estimate.source} cannot be imported by the current sharded import path.`);
    }
}
function isValidDatabaseBlockId(value) {
    return typeof value === 'string' && value.length > 0 && !value.includes('$');
}
function assertNonEmptyDocumentId(value, label) {
    if (!value) {
        throw new Error(`${label} must be a non-empty document id`);
    }
}
function isRecord(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
function isMapLike(value) {
    return isRecord(value) && typeof value.get === 'function';
}
function isArrayLike(value) {
    return isRecord(value) && typeof value.toArray === 'function';
}
function readManifestField(value, key) {
    if (isMapLike(value))
        return value.get(key);
    if (isRecord(value))
        return value[key];
    return undefined;
}
function readOptionalStringField(value, key) {
    const field = readManifestField(value, key);
    return typeof field === 'string' ? field : undefined;
}
function readStringField(value, key) {
    return readOptionalStringField(value, key) ?? '';
}
function readNumberField(value, key) {
    const field = readManifestField(value, key);
    return typeof field === 'number' ? field : Number.NaN;
}
function readShardEntries(value) {
    const shards = readManifestField(value, 'shards');
    if (Array.isArray(shards))
        return shards;
    if (isArrayLike(shards))
        return shards.toArray();
    return [];
}
/**
 * sl-d7zo.4b: Structural check for a row-shard manifest as it appears on a
 * database block's `prop:databaseShardManifest` field. Accepts either a
 * plain object (decoded JSON, blocksuite snapshot) or a Y.js `Map`-like
 * value. Returns true iff the value carries a `shards` field — empty
 * `shards: []` is a valid sharded manifest (a fresh database with zero
 * rows still has the field set). A truthy YMap *without* `shards` (corrupt
 * or stale shape) returns false so callers fail loud instead of routing
 * through the shard-loader path with no shard list.
 */
function isShardedDatabaseManifest(value) {
    if (value == null)
        return false;
    return readManifestField(value, 'shards') != null;
}
function normalizeDatabaseShardManifest(value) {
    if (!value)
        return undefined;
    const manifest = {
        databaseId: readStringField(value, 'databaseId'),
        databaseRootDocId: readStringField(value, 'databaseRootDocId'),
        workspaceId: readStringField(value, 'workspaceId'),
        storageVersion: readNumberField(value, 'storageVersion'),
        targetBytes: readNumberField(value, 'targetBytes'),
        hardLimitBytes: readNumberField(value, 'hardLimitBytes'),
        shards: readShardEntries(value).map(shard => {
            const localDocId = readOptionalStringField(shard, 'localDocId');
            if (localDocId) {
                throw new Error(`Database row shard ${readStringField(shard, 'shardId')} uses obsolete local doc id`);
            }
            return {
                shardId: readStringField(shard, 'shardId'),
                serverDocId: readStringField(shard, 'serverDocId'),
                firstRowId: readOptionalStringField(shard, 'firstRowId'),
                lastRowId: readOptionalStringField(shard, 'lastRowId'),
                rowCount: readNumberField(shard, 'rowCount'),
                encodedBytes: readNumberField(shard, 'encodedBytes'),
                status: readStringField(shard, 'status'),
            };
        }),
    };
    assertDatabaseShardManifest(manifest);
    return manifest;
}
function planDatabaseShardRowWindow(manifest, request) {
    assertDatabaseShardManifest(manifest);
    assertNonNegativeInteger(request.offset, 'Database shard window offset');
    assertNonNegativeInteger(request.limit, 'Database shard window limit');
    if (request.limit === 0) {
        throw new RangeError('Database shard window limit must be positive');
    }
    const totalCount = manifest.shards.reduce((sum, shard) => sum + shard.rowCount, 0);
    const windowEnd = Math.min(totalCount, request.offset + request.limit);
    const segments = [];
    let shardStart = 0;
    for (const [shardIndex, shard] of manifest.shards.entries()) {
        const shardEnd = shardStart + shard.rowCount;
        const segmentStart = Math.max(request.offset, shardStart);
        const segmentEnd = Math.min(windowEnd, shardEnd);
        if (segmentStart < segmentEnd) {
            segments.push({
                shard,
                shardIndex,
                globalOffset: segmentStart,
                rowOffset: segmentStart - shardStart,
                rowLimit: segmentEnd - segmentStart,
            });
        }
        shardStart = shardEnd;
        if (shardStart >= windowEnd)
            break;
    }
    return {
        offset: request.offset,
        limit: request.limit,
        totalCount,
        hasMore: windowEnd < totalCount,
        segments,
    };
}
function assertDatabaseRowShardBytesWithinLimits({ source, encodedBytes, hardLimitBytes = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES, }) {
    assertNonNegativeInteger(encodedBytes, 'Database row-shard encoded bytes');
    assertNonNegativeInteger(hardLimitBytes, 'Database row-shard hard limit');
    if (hardLimitBytes === 0) {
        throw new RangeError('Database row-shard hard limit must be positive');
    }
    if (encodedBytes <= hardLimitBytes)
        return;
    throw new RangeError(`${source} has ${encodedBytes} encoded bytes; row-shard hard limit is ${hardLimitBytes} bytes`);
}
const databaseCellValueTextEncoder = new TextEncoder();
function estimateDatabaseCellValueBytes(value) {
    if (typeof value === 'string') {
        return databaseCellValueTextEncoder.encode(value).byteLength;
    }
    if (value instanceof Uint8Array) {
        return value.byteLength;
    }
    return databaseCellValueTextEncoder.encode(JSON.stringify(value ?? null))
        .byteLength;
}
function assertDatabaseCellValueWithinShardBudget({ source, rowId, columnId, value, hardLimitBytes = exports.DATABASE_CELL_VALUE_HARD_LIMIT_BYTES, }) {
    assertNonNegativeInteger(hardLimitBytes, 'Database cell hard limit');
    if (hardLimitBytes === 0) {
        throw new RangeError('Database cell hard limit must be positive');
    }
    const encodedBytes = estimateDatabaseCellValueBytes(value);
    if (encodedBytes <= hardLimitBytes)
        return;
    throw new RangeError(`${exports.DATABASE_CELL_VALUE_TOO_LARGE_CODE}: ${source} row "${rowId}" column "${columnId}" has ${encodedBytes} encoded bytes; cell hard limit is ${hardLimitBytes} bytes. Store large values as Blob/Attachment references.`);
}
function createShardedDatabaseIdentityProps({ databaseId: providedDatabaseId, databaseRootDocId: providedDatabaseRootDocId, generateDatabaseId, workspaceId, }) {
    const databaseId = providedDatabaseId ?? generateDatabaseId?.();
    if (!databaseId) {
        throw new Error('createShardedDatabaseIdentityProps requires databaseId or generateDatabaseId');
    }
    const databaseRootDocId = providedDatabaseRootDocId ??
        (0, database_document_identity_1.createServerDatabaseRootDocId)({ workspaceId, databaseId });
    return {
        databaseId,
        databaseRootDocId,
        databaseStorageVersion: exports.DATABASE_STORAGE_VERSION,
        databaseShardManifest: createDatabaseShardManifest({
            databaseId,
            workspaceId,
            databaseRootDocId,
        }),
    };
}
function createDatabaseReferenceProps({ databaseId: providedDatabaseId, databaseRootDocId: providedDatabaseRootDocId, generateDatabaseId, workspaceId, }) {
    const databaseId = providedDatabaseId ?? generateDatabaseId?.();
    if (!databaseId) {
        throw new Error('createDatabaseReferenceProps requires databaseId or generateDatabaseId');
    }
    return {
        databaseId,
        databaseRootDocId: providedDatabaseRootDocId ??
            (0, database_document_identity_1.createServerDatabaseRootDocId)({ workspaceId, databaseId }),
        databaseStorageVersion: exports.DATABASE_STORAGE_VERSION,
    };
}
function createLegacyInlineDatabaseIdentityProps(databaseBlockId) {
    (0, database_document_identity_1.assertNonEmptyIdentifier)(databaseBlockId, 'Legacy database block id');
    return { databaseId: databaseBlockId };
}
function writeSerializedShardedDatabaseIdentity(target, input) {
    const identity = createShardedDatabaseIdentityProps(input);
    target.set('prop:databaseId', identity.databaseId);
    target.set('prop:databaseRootDocId', identity.databaseRootDocId);
    target.set('prop:databaseStorageVersion', identity.databaseStorageVersion);
    target.set('prop:databaseShardManifest', identity.databaseShardManifest);
    return identity;
}
function writeSerializedDatabaseReference(target, input) {
    const identity = createDatabaseReferenceProps(input);
    target.set('prop:databaseId', identity.databaseId);
    target.set('prop:databaseRootDocId', identity.databaseRootDocId);
    target.set('prop:databaseStorageVersion', identity.databaseStorageVersion);
    return identity;
}
function resolveDatabaseIdentity(model) {
    const databaseId = model.props.databaseId;
    const storageVersion = model.props.databaseStorageVersion;
    if (!databaseId || storageVersion === undefined) {
        return {
            status: 'missing-identity',
            blockId: model.id,
            missingDatabaseId: !databaseId,
            missingStorageVersion: storageVersion === undefined,
        };
    }
    if (storageVersion !== exports.DATABASE_STORAGE_VERSION) {
        return {
            status: 'unsupported-version',
            databaseId,
            storageVersion,
            currentStorageVersion: exports.DATABASE_STORAGE_VERSION,
        };
    }
    return {
        status: 'ready',
        databaseId,
        storageVersion,
    };
}
function assertDatabaseIdentity(model) {
    const resolved = resolveDatabaseIdentity(model);
    if (resolved.status === 'ready') {
        return resolved;
    }
    if (resolved.status === 'missing-identity') {
        throw new Error(`Database block ${resolved.blockId} is missing database identity`);
    }
    throw new Error(`Database ${resolved.databaseId} uses unsupported storage version ${resolved.storageVersion}; current version is ${resolved.currentStorageVersion}`);
}
function assertDatabaseRuntimeIdentity(model, legacyInlineStorage) {
    const resolved = resolveDatabaseIdentity(model);
    if (legacyInlineStorage &&
        resolved.status === 'missing-identity' &&
        model.props.databaseId === model.id &&
        resolved.missingStorageVersion) {
        return {
            status: 'legacy-inline',
            databaseId: model.id,
        };
    }
    return assertDatabaseIdentity(model);
}
function createDatabaseShardManifestEntry({ databaseId, workspaceId, shardId, firstRowId, lastRowId, rowCount, encodedBytes, hardLimitBytes, status, }) {
    (0, database_document_identity_1.assertNonEmptyIdentifier)(databaseId, 'Database id');
    (0, database_document_identity_1.assertNonEmptyIdentifier)(shardId, 'Database row-shard id');
    assertNonNegativeInteger(rowCount, 'Database row-shard row count');
    assertDatabaseRowShardBytesWithinLimits({
        source: `Database row shard ${shardId}`,
        encodedBytes,
        hardLimitBytes,
    });
    return {
        shardId,
        serverDocId: (0, database_document_identity_1.createServerDatabaseRowShardDocId)({
            workspaceId,
            databaseId,
            shardId,
        }),
        firstRowId,
        lastRowId,
        rowCount,
        encodedBytes,
        status,
    };
}
function createDatabaseShardManifest({ databaseId, databaseRootDocId, workspaceId, targetBytes = exports.DATABASE_ROW_SHARD_TARGET_BYTES, hardLimitBytes = exports.DATABASE_ROW_SHARD_HARD_LIMIT_BYTES, shards = [], }) {
    const manifest = {
        databaseId,
        databaseRootDocId,
        workspaceId,
        storageVersion: exports.DATABASE_STORAGE_VERSION,
        targetBytes,
        hardLimitBytes,
        shards: [...shards],
    };
    assertDatabaseShardManifest(manifest);
    return manifest;
}
function assertDatabaseShardManifest(manifest) {
    (0, database_document_identity_1.assertNonEmptyIdentifier)(manifest.databaseId, 'Database id');
    assertNonEmptyDocumentId(manifest.databaseRootDocId, 'Database root document id');
    (0, database_document_identity_1.assertNonEmptyIdentifier)(manifest.workspaceId, 'Workspace id');
    assertNonNegativeInteger(manifest.targetBytes, 'Database row-shard target');
    assertNonNegativeInteger(manifest.hardLimitBytes, 'Database row-shard hard limit');
    if (manifest.storageVersion !== exports.DATABASE_STORAGE_VERSION) {
        throw new Error(`Database shard manifest uses unsupported storage version ${manifest.storageVersion}; current version is ${exports.DATABASE_STORAGE_VERSION}`);
    }
    if (manifest.targetBytes === 0 || manifest.hardLimitBytes === 0) {
        throw new RangeError('Database row-shard byte budgets must be positive');
    }
    if (manifest.targetBytes > manifest.hardLimitBytes) {
        throw new RangeError('Database row-shard target bytes must not exceed hard limit bytes');
    }
    const shardIds = new Set();
    for (const shard of manifest.shards) {
        (0, database_document_identity_1.assertNonEmptyIdentifier)(shard.shardId, 'Database row-shard id');
        if (shardIds.has(shard.shardId)) {
            throw new Error(`Duplicate database row-shard id ${shard.shardId}`);
        }
        shardIds.add(shard.shardId);
        assertNonNegativeInteger(shard.rowCount, 'Database row-shard row count');
        assertDatabaseRowShardBytesWithinLimits({
            source: `Database row shard ${shard.shardId}`,
            encodedBytes: shard.encodedBytes,
            hardLimitBytes: manifest.hardLimitBytes,
        });
        const parsed = (0, database_document_identity_1.parseServerDatabaseRowShardDocId)(shard.serverDocId, manifest.workspaceId);
        if (!parsed ||
            parsed.databaseId !== manifest.databaseId ||
            parsed.shardId !== shard.shardId) {
            throw new Error(`Database row shard ${shard.shardId} has invalid server doc id`);
        }
    }
}
